import type { IntakeNuclearComplianceFormStepInput } from '../IntakeNuclearComplianceFormStep.schema';

export const getResetGkgValue = (required: boolean | null): IntakeNuclearComplianceFormStepInput['gkg'] => {
  if (required === null) return { required: null, measures: null, comment: '' };
  return required ? { required: true, measures: null, comment: '' } : { required: false, measures: null, comment: '' };
};

export const getResetNdaValue = (required: boolean | null): IntakeNuclearComplianceFormStepInput['nda'] => {
  if (required === null) return { required: null, availability: null };
  return required ? { required: true, availability: null } : { required: false };
};
